<template>
    <span>
        <app-navigation></app-navigation>
        <home-hero></home-hero>
        <home-details></home-details>
        <!--home-plans></home-plans-->
    </span>
</template>

<script>
import HomeHero from '@/components/HomeHero';
import HomeDetails from '@/components/HomeDetails';
import HomePlans from '@/components/HomePlans';
import AppNavigation from '../components/AppNavigation.vue';

export default {
    name: 'home',
    components: {
        HomeHero,
        HomeDetails,
        HomePlans,
        AppNavigation,
    },
};
</script>